module.exports = __webpack_public_path__ + "static/img/jun.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coaches/jun.jpg
// module id = RrqC
// module chunks = 0